<template>
  <sp-grid
    ref="paycheck-grid"
    unique="id"
    :fields="columns"
    :items="parsedPaychecks"
    :busy="loading"
    :canPaginate="true"
    :totalElements="totalElements"
    @viewAction="onView"
    @printAction="onPrint"
  >
  </sp-grid>
</template>
<script>
import { paycheckService } from '@/services';

export default {
  props: {
    paychecks: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
    totalElements: Number,
    sizePerPage: Number,
  },
  data() {
    return {
      columns: [
        { key: 'mesEAno', label: 'Referência' },
        { key: 'tipo', label: 'Tipo' },
        { key: 'alocacao.matricula', label: 'Matrícula' },
        { key: 'alocacao.filial', label: 'Vínculo' },
        { key: 'alocacao.centroDeCusto', label: 'Lotação' },
        {
          key: 'view',
          label: 'Visualizar',
          type: 'action',
          color: 'dark',
          icon: 'fas fa-eye',
        },
        {
          key: 'print',
          label: 'Imprimir',
          type: 'action',
          color: 'dark',
          icon: 'fas fa-print',
        },
      ],
    };
  },
  methods: {
    onView(index) {
      this.$emit('view', this.paychecks[index]);
    },
    async onPrint(index) {
      const { id } = this.paychecks[index];
      try {
        const file = await paycheckService.print(id);

        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(new Blob([file]));
        link.download = 'contracheque.pdf';
        link.target = '_blank';
        link.click();
      } catch (e) {
        console.log(e);
        this.$alertify.error('Erro ao gerar o PDF do contracheque');
      }
    },
  },
  computed: {
    parsedPaychecks() {
      return this.paychecks.map((paycheck) => {
        return {
          ...paycheck,
          mesEAno: `${paycheck.mes}/${paycheck.ano}`,
        };
      });
    },
  },
};
</script>
